import { useContext } from 'react';

import { FleetAccountContext } from './FleetAccountContext';

export const useFleetAccount = () => {
  const context = useContext(FleetAccountContext);
  if (context === undefined) {
    throw new Error('useFleetAccount must be used within a FleetAccountProvider');
  }
  return context;
};
